import { MfaService } from './service/mfa.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { MfaActivatePage } from './pages/modulos/mfa-activate/mfa-activate.page';
import { AppComponent } from './app.component';

@Injectable({
  providedIn: 'root',
})
export class MfaGuard implements CanActivate {
  constructor(public platfrom: Platform, public MfaService: MfaService, public modalCtrl: ModalController, public router: Router, public navController: NavController) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean>| boolean {
    
      if(!this.platfrom.is("desktop")){
        return true;
      }
      if(AppComponent.login==false){
        return true;
      }
      this.MfaService.ifexistMFA().then(data=>{
        return true;
      })

      .catch(async (error: boolean) => {
        const modal = this.modalCtrl.create({
          component: MfaActivatePage,
          canDismiss:true,
          backdropDismiss:false,
          componentProps: { }
        });
        (await modal).present();
        (await modal).onDidDismiss().then(async (modalDataResponse) => {
            return true;
        });
        
      });
      
  }
  
}
